import {getAssetUrl} from '@Utils/s3.util';
import {isWebpSupported} from '@Utils/browser.util';

const MIXED_COLOR_SWATCH_THUMB_NAME = 'mixed-color-swatch-thumb';

/**
 * Resolves the swatch thumbnail shown when the selected items have different colours, preferring the
 * webp asset where the browser supports it and falling back to the png otherwise. Used by ColorFill
 * to render its "mixed colours" state; callers pass the `isColorMixed` boolean rather than this URL.
 */
export function getMixedColorSwatchThumbUrl(): string {
  return getAssetUrl(`${MIXED_COLOR_SWATCH_THUMB_NAME}.${isWebpSupported() ? 'webp' : 'png'}`);
}
